// Features
import produce from "immer";
import { EvaluationsSchedulers, EvaluationsTemplates } from "../actions/";
// Types
import type { Action } from "deox";
import type { PayloadObject, UndefinedNull } from "../../types/common.types";
import type { EvaluationsTypes } from "../../types/evaluations.types";
type StepsEvaluationsSchedulersCreate =
  //Init: Standard | Third Party
  | "setup-all-select-evaluation-schedulers"
  // Autogenerate: start-end rotations | every case | Flexible: specific date (Shared Standard & Third Party)
  | "setup-all-select-evaluation-schedulers-type"
  //Autogenerate: Based At the start-end rotations | Based On every case log (Only Standard)
  | "setup-autogenerate-select-type"
  | "setup-autogenerate-select-type-evaluators"
  | "setup-autogenerate-select-criteria"
  //Flexible: Based On specific date (Only Standard)
  | "setup-flexible-select-type"
  | "setup-flexible-select-evaluators"
  | "setup-flexible-select-targets"
  //Third Party: Based On public link evaluations (Only Third Party)
  //Can be start-end rotations | every case log | specific date
  | "setup-third-party-send-public-link-email"
  | "setup-third-party-select-type"
  | "setup-third-party-select-criteria-targets"
  | "setup-third-party-send-reminders"
  //Last Steps: (Shared Standard & Third Party)
  | "setup-all-template-reminders"
  | "setup-all-name-description-date-options"
  | "summary";
type InitStepsEvaluationsSchedulersCreate = {
  "setup-all-select-evaluation-schedulers": {
    typeOfScheduler: "standard" | "third_party" | UndefinedNull;
  };
  "setup-all-select-evaluation-schedulers-type": {
    triggeringCriteria:
      | "start_rotation"
      | "end_rotation"
      | "every_case_log"
      | "custom_period"
      | UndefinedNull;
  };
};
type AutogenerateStepsEvaluationsSchedulersCreate = {
  "setup-autogenerate-select-type": {
    evaluatorsRole: "Students" | "Preceptors" | UndefinedNull;
    immediateCreation: boolean;
    multipleAnswers: boolean;
    multipleTargets: boolean;
    targets: [] | ["Others"];
    targetsRole: "Students" | "Preceptors" | UndefinedNull;
    type:
      | "UserEvaluations"
      | "InstitutionEvaluations"
      | "CustomEvaluations"
      | UndefinedNull;
  };
  "setup-autogenerate-select-type-evaluators": {
    evaluatorsFrom:
      | "all"
      | "only_evaluators"
      | "only_from_case_logs"
      | UndefinedNull;
    multipleEvaluators: boolean;
    targetsFrom:
      | "all"
      | "only_evaluators"
      | "only_from_case_logs"
      | UndefinedNull;
  };
  "setup-autogenerate-select-criteria": {
    cohorts: PayloadObject[];
    programs: PayloadObject[];
    institutions: PayloadObject[];
    rotations: PayloadObject[];
  };
};
type FlexibleStepsEvaluationsSchedulersCreate = {
  "setup-flexible-select-type": {
    immediateCreation: boolean;
    multipleAnswers: boolean;
    type:
      | "UserEvaluations"
      | "InstitutionEvaluations"
      | "CompanyEvaluations"
      | "CustomEvaluations"
      | UndefinedNull;
  };
  "setup-flexible-select-evaluators": {
    evaluators: PayloadObject[];
    evaluatorsRole:
      | "Students"
      | "Preceptors"
      | "CompanyAdministrators"
      | "InstitutionAdministrators"
      | UndefinedNull;
    multipleEvaluators: boolean;
  };
  "setup-flexible-select-targets": {
    multipleTargets: boolean;
    targets: PayloadObject[];
    targetsRole:
      | "Students"
      | "Preceptors"
      | "CompanyAdministrators"
      | "InstitutionAdministrators"
      | UndefinedNull;
  };
};
type ThirdPartyStepsEvaluationsSchedulersCreate = {
  "setup-third-party-send-public-link-email": {
    sendPublicLinkTo: { email: string; name: string }[];
  };
  "setup-third-party-select-type": {
    evaluatorsRole: "NoRegisteredUser";
    immediateCreation: boolean;
    multipleAnswers: boolean;
    multipleEvaluators: boolean;
    multipleTargets: boolean;
    targetsRole: "Students";
    type: "PublicEvaluations";
  };
  "setup-third-party-select-criteria-targets": {
    criteria: {
      cohorts: PayloadObject[];
      programs: PayloadObject[];
      institutions: PayloadObject[];
    };
    targets: PayloadObject[];
  };
  "setup-third-party-send-reminders": {
    notifyTo: { email: string; name: string }[];
  };
};
type FinalStepsEvaluationsSchedulersCreate = {
  "setup-all-template-reminders": {
    evaluationTemplateId: string | UndefinedNull;
    reminderMessageBeforeOpen: string | UndefinedNull;
    daysBeforeOpenToSendReminder: number | UndefinedNull;
    reminderMessageBeforeClose: string | UndefinedNull;
    daysBeforeCloseToSendReminder: number | UndefinedNull;
  };
  "setup-all-name-description-date-options": {
    isActive: boolean;
    name: string | UndefinedNull;
    description: string | UndefinedNull;
    options: {
      openDaysBefore: number | UndefinedNull;
      keepEvaluationsOpen: number | UndefinedNull;
      period: "date_range" | "every_week_day" | "every_month";
      from: string | UndefinedNull;
      to: string | UndefinedNull;
      every: string | UndefinedNull;
    };
  };
};
export type StateEvaluationsSchedulersCreate = {
  stepCreateEvaluationsSchedulers: StepsEvaluationsSchedulersCreate;
} & InitStepsEvaluationsSchedulersCreate &
  AutogenerateStepsEvaluationsSchedulersCreate &
  FlexibleStepsEvaluationsSchedulersCreate &
  ThirdPartyStepsEvaluationsSchedulersCreate &
  FinalStepsEvaluationsSchedulersCreate;
export type StateEvaluationsSchedulersTabs = {
  panes: Array<{
    menuItem: string;
    name: EvaluationsTypes;
  }>;
  selected: number;
};
type State = {
  lastFetching: Date | UndefinedNull;
  evaluationsSchedulersTabs: StateEvaluationsSchedulersTabs;
  evaluationScheduler: PayloadObject | UndefinedNull;
  evaluationSchedulerId: string | UndefinedNull;
  evaluationsSchedulers: {
    UserEvaluations: PayloadObject[];
    InstitutionEvaluations: PayloadObject[];
    CompanyEvaluations: PayloadObject[];
    CustomEvaluations: PayloadObject[];
    PublicEvaluations: PayloadObject[];
  };
  evaluationsSchedulersCreate: StateEvaluationsSchedulersCreate;
};
type EvaluationsSchedulersActionReducers = Action<
  string,
  {
    evaluationScheduler: State["evaluationScheduler"];
    evaluationSchedulerId: State["evaluationSchedulerId"];
    evaluationSchedulers: State["evaluationsSchedulers"];
    data: StateEvaluationsSchedulersCreate;
    selected: State["evaluationsSchedulersTabs"]["selected"];
  }
>;
// Evaluations Schedulers Reducer
export const initialStateEvaluationsSchedulersCreate: StateEvaluationsSchedulersCreate =
  {
    stepCreateEvaluationsSchedulers: "setup-all-select-evaluation-schedulers",
    "setup-all-select-evaluation-schedulers": {
      typeOfScheduler: null,
    },
    "setup-all-select-evaluation-schedulers-type": {
      triggeringCriteria: null,
    },
    "setup-autogenerate-select-type": {
      evaluatorsRole: null,
      immediateCreation: false,
      multipleAnswers: false,
      multipleTargets: false,
      targets: [],
      targetsRole: null,
      type: null,
    },
    "setup-autogenerate-select-type-evaluators": {
      evaluatorsFrom: null,
      multipleEvaluators: false,
      targetsFrom: null,
    },
    "setup-autogenerate-select-criteria": {
      cohorts: [],
      programs: [],
      institutions: [],
      rotations: [],
    },
    "setup-flexible-select-type": {
      immediateCreation: false,
      multipleAnswers: false,
      type: null,
    },
    "setup-flexible-select-evaluators": {
      evaluators: [],
      evaluatorsRole: null,
      multipleEvaluators: false,
    },
    "setup-flexible-select-targets": {
      multipleTargets: false,
      targets: [],
      targetsRole: null,
    },
    "setup-third-party-send-public-link-email": {
      sendPublicLinkTo: [],
    },
    "setup-third-party-select-type": {
      evaluatorsRole: "NoRegisteredUser",
      immediateCreation: true,
      multipleAnswers: true,
      multipleEvaluators: true,
      multipleTargets: true,
      targetsRole: "Students",
      type: "PublicEvaluations",
    },
    "setup-third-party-select-criteria-targets": {
      criteria: {
        cohorts: [],
        programs: [],
        institutions: [],
      },
      targets: [],
    },
    "setup-third-party-send-reminders": {
      notifyTo: [],
    },
    "setup-all-template-reminders": {
      evaluationTemplateId: null,
      reminderMessageBeforeOpen: null,
      daysBeforeOpenToSendReminder: null,
      reminderMessageBeforeClose: null,
      daysBeforeCloseToSendReminder: null,
    },
    "setup-all-name-description-date-options": {
      isActive: true,
      name: null,
      description: null,
      options: {
        openDaysBefore: null,
        keepEvaluationsOpen: null,
        period: "date_range",
        from: null,
        to: null,
        every: null,
      },
    },
  };
const initialStateEvaluationsSchedulersTabs: StateEvaluationsSchedulersTabs = {
  panes: [
    { menuItem: "User Evaluations", name: "UserEvaluations" },
    { menuItem: "Clinic Evaluations", name: "InstitutionEvaluations" },
    { menuItem: "School Evaluations", name: "CompanyEvaluations" },
    { menuItem: "Custom Evaluations", name: "CustomEvaluations" },
    // { menuItem: "Third Party Evaluations", name: "PublicEvaluations" }, // DISABLED: third-party feature not supported in current backend
  ],
  selected: 0,
};
const initialState: State = {
  lastFetching: null,
  evaluationsSchedulersTabs: initialStateEvaluationsSchedulersTabs,
  evaluationScheduler: null,
  evaluationSchedulerId: null,
  evaluationsSchedulers: {
    UserEvaluations: [],
    InstitutionEvaluations: [],
    CompanyEvaluations: [],
    CustomEvaluations: [],
    PublicEvaluations: [], // DISABLED: kept for type compatibility; tab hidden via panes above
  },
  evaluationsSchedulersCreate: initialStateEvaluationsSchedulersCreate,
};
const evaluationsSchedulers: (
  state: State,
  action: EvaluationsSchedulersActionReducers
) => State = produce(
  (draft: State, action: EvaluationsSchedulersActionReducers) => {
    switch (action.type) {
      case EvaluationsSchedulers.EVALUATIONS_SCHEDULERS_SET_TAB_SELECTED:
        draft.evaluationsSchedulersTabs.selected = action.payload.selected;
        break;
      case EvaluationsSchedulers.EVALUATIONS_SCHEDULERS_FETCH_EVALUATIONS_SCHEDULERS_SUCCESS:
        draft.lastFetching = new Date();
        draft.evaluationsSchedulers = action.payload.evaluationSchedulers;
        break;
      case EvaluationsSchedulers.EVALUATIONS_SCHEDULERS_SET_EVALUATION_SCHEDULER_ID:
        draft.evaluationSchedulerId = action.payload.evaluationSchedulerId;
        break;
      case EvaluationsSchedulers.EVALUATIONS_SCHEDULERS_FETCH_EVALUATION_SCHEDULER_SUCCESS:
      case EvaluationsSchedulers.EVALUATIONS_SCHEDULERS_EDIT_SUCCESS:
        draft.evaluationScheduler = action.payload.evaluationScheduler;
        break;
      case EvaluationsSchedulers.EVALUATIONS_SCHEDULERS_DELETE_SUCCESS:
        const tabEvSchedSelected =
          draft.evaluationsSchedulersTabs.panes[
            draft.evaluationsSchedulersTabs.selected
          ]["name"];
        const newEvaluationsSchedulers = {
          ...draft.evaluationsSchedulers,
          [tabEvSchedSelected]: draft.evaluationsSchedulers[
            tabEvSchedSelected
          ].filter(({ _id }) => _id !== action.payload.evaluationSchedulerId),
        };
        draft.lastFetching = new Date();
        draft.evaluationsSchedulers = newEvaluationsSchedulers;
        break;
      case EvaluationsSchedulers.EVALUATIONS_SCHEDULERS_RESET_EVALUATION_SCHEDULERS_LOADED:
      case EvaluationsTemplates.EVALUATIONS_TEMPLATES_RESET_EVALUATION_TEMPLATE_LOADED:
        draft.evaluationSchedulerId = initialState.evaluationSchedulerId;
        draft.evaluationsSchedulersCreate =
          initialState.evaluationsSchedulersCreate;
        break;
      // Evaluation Schedulers Create or Update:
      case EvaluationsSchedulers.EVALUATIONS_SCHEDULERS_CREATE_SUCCESS:
        draft.lastFetching = null;
        break;
      case EvaluationsSchedulers.EVALUATIONS_SCHEDULERS_EVALUATION_CREATE_UPDATE_STEP:
        draft.evaluationsSchedulersCreate = {
          ...draft.evaluationsSchedulersCreate,
          ...action.payload.data,
        };
        break;
      case EvaluationsSchedulers.EVALUATIONS_SCHEDULERS_EVALUATION_CREATE_RESET:
        draft.evaluationsSchedulersCreate =
          initialStateEvaluationsSchedulersCreate;
        break;
    }
  },
  initialState
);
export default evaluationsSchedulers;
